import axios from 'axios'
import { publicPath } from '@/../vue.config'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'

export default class CadenaResultadosDesempenioAcademico {
  worksheet
  buffer

  constructor(evaluacionDesempenio, personal) {
    this.evaluacionDesempenio = evaluacionDesempenio
    this.personal = personal
  }

  async getFileTemplate() {
    try {
      const file = await axios(`${publicPath}cadena_resultados_desempeño_academico.xlsx`, {
        responseType: 'arraybuffer',
      })
      return file.data
    } catch (error) {
      console.error('Error al obtener la plantilla de la cadena de resultados:', error)
      throw new Error('No se pudo obtener la plantilla de la cadena de resultados.')
    }
  }

  writeCell(cellPosition, value) {
    let cell = null
    cell = this.worksheet.getCell(cellPosition)

    if (value) {
      cell.value = value
    } else {
      cell.value = ''
    }
  }

  writePersonalData() {
    const evaluacion =
      this.evaluacionDesempenio.respetoPrincipiosValores ||
      this.evaluacionDesempenio.respetoPrincipios ||
      this.evaluacionDesempenio.disciplinaAdministrativa

    this.writeCell(
      'D9',
      `${this.personal.apaterno} ${this.personal.amaterno} ${this.personal.nombre} ${this.personal.segundoNombre}`
    )
    this.writeCell('F9', this.personal.rfc)
    this.writeCell('G9', evaluacion?.institucionSeguridadAspira ?? '')
    this.writeCell('H9', evaluacion?.aspiranteAlPuesto ?? '')
    this.writeCell('I9', evaluacion?.CatMunicipio?.catEstado?.title ?? '')
    this.writeCell('J9', evaluacion?.CatMunicipio?.nombre ?? '')
    this.writeCell('K9', '') // TODO: Mapear fecha de inicio de formación inicial.
    this.writeCell('L9', '') // TODO: Mapear fecha de conclusión de formación inicial.
    this.writeCell('M9', evaluacion?.fechaAplicacion ?? '')
  }

  writeRespetoPrincipiosValores() {
    const evaluacion = this.evaluacionDesempenio.respetoPrincipiosValores

    this.writeCell('N9', evaluacion.fechaAplicacion)
    this.writeCell('O9', evaluacion.puntajeTotal)
    this.writeCell('P9', evaluacion.calificacion)
    this.writeCell('Q9', evaluacion.CatResultado.title)
  }

  writeDisciplinaAdministrativa() {
    const evaluacion = this.evaluacionDesempenio.disciplinaAdministrativa

    this.writeCell('R9', evaluacion.fechaAplicacion)
    this.writeCell('S9', evaluacion.puntajeTotal)
    this.writeCell('T9', evaluacion.calificacion)
    this.writeCell('U9', evaluacion.CatResultado.title)
  }

  writeRendimientoProfesionalismo() {
    const evaluacion = this.evaluacionDesempenio.rendimientoProfesionalismo

    this.writeCell('V9', evaluacion.fechaAplicacion)
    this.writeCell('W9', evaluacion.puntajeTotal)
    this.writeCell('X9', evaluacion.calificacion)
    this.writeCell('Y9', evaluacion.CatResultado.title)
  }

  download() {
    saveAs(
      new Blob([this.buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      'cadena_resultados_desempeño_academico.xlsx'
    )
  }

  async generateXlsx() {
    try {
      const template = await this.getFileTemplate()
      const workbook = new ExcelJS.Workbook()
      await workbook.xlsx.load(template)
      const DEFUALT_WORKSHEET = 1
      this.worksheet = workbook.getWorksheet(DEFUALT_WORKSHEET)

      this.writePersonalData()

      if (this.evaluacionDesempenio.respetoPrincipiosValores) {
        this.writeRespetoPrincipiosValores()
      }
      if (this.evaluacionDesempenio.disciplinaAdministrativa) {
        this.writeDisciplinaAdministrativa()
      }
      if (this.evaluacionDesempenio.rendimientoProfesionalismo) {
        this.writeRendimientoProfesionalismo()
      }

      this.worksheet.removeConditionalFormatting()
      this.buffer = await workbook.xlsx.writeBuffer()

      this.download()
    } catch (error) {
      console.error('Error al generar la cadena de resultados:', error)
      throw new Error('No se pudo generar la cadena de resultados.')
    }
  }
}
